export const SELECTOR__AR_SUPPORTED = '#AugmentedRealitySupported';
export const SELECTOR__AR_NOT_SUPPORTED = '#AugmentedRealityNotSupported';
export const SELECTOR__BACKGROUND_CHOOSER = '#SelBackgroundChooser';
export const SELECTOR_CONTAINER = '#Container3dModel';
export const SELECTOR__BTN_TOGGLE_DIMENSIONS = '#BtnToggleDimensions';
export const SELECTOR__BTN_TOGGLE_ELECTRICAL_CONNECTION_COVER =
    '#BtnToggleElectricalConnectionCover';
export const SELECTOR__BTN_TOGGLE_ILLUMINANT = '#BtnToggleIlluminant';
export const SELECTOR__BTN_ROTATE_CAMERA = '#BtnRotateCamera';
export const SELECTOR__BTN_TOGGLE_MOUNT = '#BtnToggleMount';
export const SELECTOR__BTN_TOGGLE_OPTICS = '#BtnToggleOptics';
export const SELECTOR__BTN_TOGGLE_SENSOR = '#BtnToggleSensor';
export const SELECTOR__BTN_RESET_CAMERA = '#BtnResetCamera';
export const SELECTOR__BTN_TRIGGER_ANIMATIONS = '#BtnTriggerAnimations';
export const SELECTOR__CONTAINER_QR_AR = '.cont-qr-ar';
export const SELECTOR__CONTAINER_PAGE_CONTENT = '.cont-page-content';
export const SELECTOR__LOADER_CONTAINER = '.cont-loader';
export const SELECTOR__LNK_AUGMENTED_REALITY = '#LnkAugmentedReality';

export const QUERY_PARAM__SHOW_ENVIRONMENT = 'showEnvironment';
export const QUERY_PARAM__ALLOW_AR = 'allowAR';
